import React from 'react';
import { Search, TrendingUp } from 'lucide-react';

const KeywordResearchPanel = ({ keywords, onRefresh }) => {
  const sortedByVolume = [...keywords]?.sort((a, b) => b?.search_volume - a?.search_volume);

  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
      <div className="flex items-center mb-4">
        <Search className="w-6 h-6 text-green-600 mr-2" />
        <h3 className="text-lg font-semibold text-gray-900">Portfolio de mots-clés</h3>
      </div>

      <div className="overflow-x-auto">
        <table className="w-full">
          <thead className="bg-gray-50 border-b border-gray-200">
            <tr>
              <th className="px-4 py-3 text-left text-xs font-medium text-gray-600 uppercase">Mot-clé</th>
              <th className="px-4 py-3 text-left text-xs font-medium text-gray-600 uppercase">Volume</th>
              <th className="px-4 py-3 text-left text-xs font-medium text-gray-600 uppercase">Difficulté</th>
              <th className="px-4 py-3 text-left text-xs font-medium text-gray-600 uppercase">Position</th>
              <th className="px-4 py-3 text-left text-xs font-medium text-gray-600 uppercase">Opportunité</th>
              <th className="px-4 py-3 text-left text-xs font-medium text-gray-600 uppercase">Catégorie</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200">
            {sortedByVolume?.map((keyword) => {
              const opportunity = keyword?.search_volume > 500 && keyword?.difficulty === 'easy' ?'high'
                : keyword?.search_volume > 300 && keyword?.difficulty !== 'hard' ?'medium' :'low';

              return (
                <tr key={keyword?.id} className="hover:bg-gray-50">
                  <td className="px-4 py-3 text-sm text-gray-900 font-medium">{keyword?.keyword}</td>
                  <td className="px-4 py-3 text-sm text-gray-600">
                    <div className="flex items-center">
                      <TrendingUp size={14} className="text-green-600 mr-1" />
                      {keyword?.search_volume?.toLocaleString()}
                    </div>
                  </td>
                  <td className="px-4 py-3">
                    <span className={`px-2 py-1 text-xs font-medium rounded-full ${
                      keyword?.difficulty === 'easy' ? 'bg-green-100 text-green-800' :
                      keyword?.difficulty === 'medium'? 'bg-yellow-100 text-yellow-800' : 'bg-red-100 text-red-800'
                    }`}>
                      {keyword?.difficulty === 'easy' ? 'Facile' : keyword?.difficulty === 'medium' ? 'Moyen' : 'Difficile'}
                    </span>
                  </td>
                  <td className="px-4 py-3 text-sm text-gray-900">
                    {keyword?.current_ranking ? (
                      <span className={`font-medium ${
                        keyword?.current_ranking <= 10 ? 'text-green-600' :
                        keyword?.current_ranking <= 20 ? 'text-yellow-600': 'text-red-600'
                      }`}>
                        #{keyword?.current_ranking}
                      </span>
                    ) : (
                      <span className="text-gray-400">-</span>
                    )}
                  </td>
                  <td className="px-4 py-3">
                    <span className={`px-2 py-1 text-xs font-medium rounded-full ${
                      opportunity === 'high' ? 'bg-green-100 text-green-800' :
                      opportunity === 'medium'? 'bg-yellow-100 text-yellow-800' : 'bg-gray-100 text-gray-800'
                    }`}>
                      {opportunity === 'high' ? 'Élevée' : opportunity === 'medium' ? 'Moyenne' : 'Faible'}
                    </span>
                  </td>
                  <td className="px-4 py-3 text-sm text-gray-600 capitalize">{keyword?.category}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      {keywords?.length === 0 && (
        <div className="text-center py-12">
          <Search className="w-12 h-12 text-gray-400 mx-auto mb-3" />
          <p className="text-gray-500">Aucun mot-clé trouvé avec ces filtres</p>
        </div>
      )}
    </div>
  );
};

export default KeywordResearchPanel;